<template>
    <div>
        <div class="step" :class="{'step-active': activeStep === 'adjustTemplate'}" @click="goTo('adjustTemplate')">
            <div>
                <div class="circle">
                    <spinner v-if="goingTo === 'adjustTemplate' && loading"></spinner>
                    <i class="fa fa-pencil"></i>
                </div>
            </div>
            <div>
                <div class="title">
                    <h4 v-text="$lang.get('trans.adjust_template')"></h4>
                </div>
                <div class="caption">
                    <p v-html="$lang.get('trans.adjust_template_info_text')"></p>
                </div>
            </div>
        </div>
        <div class="step" :class="{'step-active': activeStep === 'preview'}" @click="goTo('preview')">
            <div>
                <div class="circle">
                    <spinner v-if="goingTo === 'preview' && loading"></spinner>
                    <i class="fa fa-eye"></i>
                </div>
            </div>
            <div>
                <div class="title">
                    <h4 v-text="$lang.get('trans.preview_documents')"></h4>
                </div>
                <div class="caption">
                    <p v-html="$lang.get('trans.preview_documents_info_text')"></p>
                </div>
            </div>
        </div>
        <div class="step" :class="{'step-active': activeStep === 'generate'}" @click="goTo('generate')">
            <div>
                <div class="circle">
                    <spinner v-if="goingTo === 'generate' && loading"></spinner>
                    <i class="fa fa-cogs"></i>
                </div>
            </div>
            <div>
                <div class="title">
                    <h4 v-text="$lang.get('trans.generate_documents')"></h4>
                </div>
                <div class="caption">
                    <p v-html="$lang.get('trans.generate_documents_info_text')"></p>
                </div>
            </div>
        </div>
        <div v-if="showFinishButton === 'show'" class="step" :class="{'step-active': activeStep === 'done'}">
            <div>
                <div class="circle">
                    <spinner v-if="goingTo === 'done' && loading"></spinner>
                    <i class="fa fa-check"></i>
                </div>

            </div>
            <div>
                <div class="title">
                    <h4 v-text="$lang.get('trans.done')"></h4>
                </div>
                <div class="caption">
                  <p v-html="$lang.get('trans.all_done')"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from 'components/spinner/Spinner'

    export default {
        name: "generator-steps",

        components: {
            Spinner
        },

        props: {
            activeStep: {
                type: String
            },
            showFinishButton: {
                type: String
            },
        },

        data() {
            return {
                loading: false,
                goingTo: null
            }
        },

        methods: {
            goTo(step) {
                setTimeout(() => {
                    this.startLoading(step)
                }, 300)

                let stepUrl = typeof Sincron.steps[step] !== 'undefined' ? Sincron.steps[step] : null

                if (stepUrl) {
                    window.location.href = stepUrl
                    return
                }

                this.$toaster.error('Incorrect URL for the provided step')
            },

            startLoading(step) {
                this.loading = true
                this.goingTo = step
            }
        },

        mounted() {
            eventBus.$on('show-spinner', () => {
                this.startLoading(this.activeStep)
            })

            eventBus.$on('hide-spinner', () => {
                this.loading = false
            })

            $(document).ready(() => {
                $(this.$el).scrollToFixed()
            })
        }
    }
</script>

<style scoped>
    /* Steps */
    .step {
        position: relative;
        min-height: 12em;
        color: #858585;
        cursor: pointer;
    }


    .step + .step {
        margin-top: 5px
    }
    .step > div:first-child {
        position: static;
        height: 0;
    }
    .step > div:not(:first-child) {
        margin-left: 5.5em;
        margin-top: .5em;
        padding-left: 1em;
    }
    .step.step-active {
        color: #000000
    }
    .step.step-active .circle {
        background-color: #000000;
    }

    .step.step-active:hover .circle, .step.step-active .circle:hover {
        background-color: #373737;
    }

    /* Circle */
    .circle {
        background: #a5a5a5;
        position: relative;
        width: 5.5em;
        height: 5.5em;
        line-height: 5.5em;
        border-radius: 100% !important;
        color: #fff;
        text-align: center;
        box-shadow: 0 0 0 3px #fff;
    }

    .circle i {
        font-size: 1.5em;
    }
    .step:hover .circle, .circle:hover {
        cursor: pointer;
        background: #858585;
    }

    /* Vertical Line */
    .circle:after {
        content: ' ';
        position: absolute;
        display: block;
        top: 4px;
        right: 50%;
        bottom: 4px;
        left: 50%;
        height: 100%;
        width: 2px;
        transform: scale(1, 2);
        transform-origin: 50% -100%;
        background-color: rgba(0, 0, 0, 0.25);
        z-index: 0;
    }
    .step:last-child .circle:after {
        display: none
    }

    /* Stepper Titles */
    .title {
        line-height: 1.5em;
        font-weight: bold;
    }
    .caption {
        font-size: 0.9em;
    }
</style>